"use strict";

Platform.F7Popup = class Platform_F7Popup extends PF.Widget
	{
	static get options()
		{
		return {
			dom: {
				content: undefined,
			},
			html: PF.F7Popup.templates,
			title: "",
			f7config: {},
			routeConfig: {},
			path: 'popup-' + PF.H.randomString(5),
			parentPath: undefined, //app.currentPage.path
		};
		}

	static get templates()
		{
		// language=HTML
		return {
			popup: `
				<div class="popup page">
					<div class="navbar" pf="navBar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner" pf="navbarInner">
							<div class="left">
								<a href="#" class="link " pf="close">
									<i class="icon icon-back"></i>
								</a>
							</div>
							<div class="center" pf="popupTitle"></div>
						</div>
					</div>
					<div class="page-content" pf="pageContent">
					</div>
				</div>
			`
		};
		}

	init()
		{
		this.opened = false;
		this.dom.loads(this.html);
		if (this.html.content !== undefined)
			{
			this.dom.load(this.html.content, 'content');
			}
		this.dom.pageContent.append(this.dom.content);

		// if(app.currentPage.path)


		this.dom.close.on('click', () => app.router.back()/* this.f7popup.close()*/);
		this.bindDom({popupTitle: 'text'}, 'title');
		}

	open()
		{
		if (this.inRoutes !== true)
			{
			this.parentPath = PF.H.get(app, 'router.currentRoute.url', '', '');
			this.fullPath = this.parentPath + '/' + this.path;
			this.route = {
				path: this.fullPath,
				beforeLeave: (routeTo, routeFrom, resolve, reject) => {
					// this.f7popup.close();
					resolve();
				}
			};
			app.mainView.routes.push(this.route);
			this.inRoutes = true;

			window.addEventListener("beforeunload", (evt) => {
				this.close();
				// evt.returnValue = '';
			});
			}

		this.f7popup = app.f7.popup.create({
			el: this.dom.popup.node,
			...this.f7config,
		});
		this.f7popup.on('closed', () => {
			this.opened = false;
			// let index = app.mainView.routes.indexOf(this.route);
			// app.mainView.routes.splice(index, 1);
		});
		this.f7popup.on('open', () => {
			this.trigger('open');
		});
		this.f7popup.on('opened', () => {
			this.trigger('opened');
		});
		this.route.popup = this.f7popup;

		app.router.navigate(this.fullPath);
		this.opened = true;


		}

	close()
		{
		if (this.f7popup !== undefined && this.f7popup.destroyed !== true)
			{
			this.f7popup.close();
			// app.router.back();
			}

		}
	};